
export default {
    'addressMain': 'OATXL',//通讯录
    'applicationAll': 'OAYYZX',//应用中心公告
    'main': 'OASY',//首页
    'CreateMember': 'TJCY',//添加成员
    'manageRole': 'QXGL',//权限管理
    'manageApplication': 'YYGL',//应用管理
    'manageVersion': 'BBGL',//版本管理
    'applicationRecord': 'FBGG',//发布公告
    "applicationManagement": 'FLGL',//分类管理
    'error':'ERROR',
    'login':'LOGIN',
    'memberDetail':'MEMBERDETAIL',
    "noticeDetail":'NOTICEDETAIL',
    "applicationDetailTwo":'APPDETAILTWO',
    "applicationDetail":'APPDETAIL',
    "applicationFn":'GGGL',
    'manageApplication':'YYGL',
    'manageVersion':'BBGL',
    "test":'TEST',
    "testEditor":'TEST',
    'applicationApproval':'应用中心默认永久权限',
    'applicationWorkbench':'应用中心默认永久权限',
    'applicationFormManage':'SPGL',
    'applicationRecList':'SPGL',
    'expenseReimburs':'SPGL',
    'costBasis':'SPGL',
    'designForm':'SPGL',
    'designProcess':'SPGL',
    'applicationFormTemplate':'SPGL',
    'applyForm':'应用中心默认永久权限',
    'newApplyForm':'应用中心默认永久权限',
    'copyMeForm':'应用中心默认永久权限',
    'copyMeFormNew':'应用中心默认永久权限',
    'library':'应用中心默认永久权限',
    'roleManage':'应用中心默认永久权限',
    'workReport':'应用中心默认永久权限',
    'writeReport':'应用中心默认永久权限',
    'reportSuccess':'应用中心默认永久权限',
    'lookReport':'应用中心默认永久权限',
    'submitReport':'应用中心默认永久权限',
    'reportDetail':'应用中心默认永久权限',
    "applicationProcessManage":'SPGL',
    "attendanceGroup":'KQDK',
    "attendGroupAdd":'KQZSZ',
    "monthlyStatist":'YDTJ',
    "dailyStatist":'MRTJ',
    "punchTime":'DKSJ',
    "originalRecord":'YSJL',
    "viewDeptStaff":"CKLZRY",
    "bmsProject":"proj",
    "bmsAuth":"BMS-AUTH",//权限设置
    "IntraWarNews":"应用中心默认永久权限",//站内消息
    "setMessage":"MESSAGE",//消息设置
    "busiOppoStatusView":"proj",//查看
    "busiOppoStatus":"proj-add",//新建商机
    "busiOppoStatus":"oppo-look",//商机查看
    "busiOppoItemStatus":"oppoitem-look",//商机立项查看
    "busiOppoItemStatusView":"oppoitem-look",//商机立项查看
    "projModeStatus":"mode-look",//模式选中
    "cxccBidStatus":"cxccbid-look",//配合运营商投标查看
    "cxccBidStatusView":"cxccbid-look",//配合运营商投标查看
    "bidPrepareStatus":"bidprepare-look",//投标准备
    "bidPrepareStatusView":"bidprepare-look",//投标准备
    "winbidStatus":"winbid-look",//中标查看
    "winbidStatusView":"winbid-look",//中标查看
    "projItemStatus":"projitem-look",//项目立项查看
    "projItemStatusView":"projitem-look",//项目立项查看
    "projectBudgetApproval":"budgetapprove-look",//预算审批查看
    "projectBudgetApprovalDetail":"budgetapprove-look",
    "signContract":"contract-look",//签订合同查看
    "signContractDetail":"contract-look",//签订合同查看
    "projectControl":"projcontrol-look",//项目管控查看
    "projectControlDetail":"projcontrol-look",//项目管控查看
    "projectAcceptance":"projvalid-look",//项目验收查看
    "projectAcceptanceDetail":"projvalid-look",//项目验收查看
    "settlement":"projsettle-look",//项目结算查看
    "settlementDetail":"projsettle-look",
    "projectFiles":"projfile",//项目归档查看
    "budgetApproval":"budgetreport",//预算报批
    "budgetApprovalDetail":"budgetreport-look",//--查看
    "budgetApprovalEdit":"budgetreport-edit",//--删除
}



// WEBPACK FOOTER //
// ./src/router/routerAuthor.js